module.exports = {
  Others: '其他',
  YouToViewOrFiles: '你没有查看其它人上传或者打印的文件的权限.',
  BookingAgent: '订舱代理',
  BasicInformation: '基本信息',
  FileHistory: '文件历史',
  Cancel: '取消',
  Save: '保存',
  SynchronizeFees: '同步费用',
  ProjectNameCannotBeEmpty: '项目名称不能为空！',
  CustomerNameCannotBeEmpty: '客户名称不能为空！',
  ProjectCycleCannotBeEmpty: '项目周期不能为空！',
  EndBeEarlierThanDate: '结束日期不能早于开始日期！',
  AccountingCurrencyCannotBeEmpty: '核算币种不能为空！',
  ProjectManagerCannotBeEmpty: '项目经理不能为空！',
  ProjectDepartmentCannotBeEmpty: '项目部门不能为空！',
  ProjectCompanyCannotBeEmpty: '项目公司不能为空！',
  SaveSuccessfully: '保存成功',
  TheStatusCannotBeEdited: '当前项目状态无法进行编辑操作！',
  TheStatusCannotBeDeleted: '当前项目状态无法进行删除操作',
  PleaseToDeleteTheNumber: '请确认是否删除编号',
  Prompt: '提示',
  Confirm: '确定',
  DeleteSuccessfully: '删除成功',
  CancelledDeletion: '已取消删除',
  ProjectStatusCompleted: '项目状态已完成',
  PleaseCanCloseTheNumber: '请确认可以关闭编号',
  ClosedSuccessfully: '关闭成功',
  ClosedCancelled: '已取消关闭',
  ProjectStatusInProgress: '项目状态进行中',
  PleaseNeedToReopenNumber: '请确认需要重新打开编号',
  SuccessfullyOpened: '打开成功',
  CancelledOpening: '已取消打开',
  PleaseSelectARecord: '请选择一条记录！',
  DeletedSuccessfully: '删除成功',
  DeletionCancelled: '已取消删除',
  CancelledClosing: '已取消关闭',
  OpenedSuccessfully: '打开成功',
  XNotAllowViewOrDownload: '{0}文件不允许任何人查看或下载.',
  NoPermissionView: '你没有权限查看或下载{0}文件',
  PleaseToDeleteTheProject: '请确认是否删除编号{0}的项目'
}
